<template>
<div>
    <trademark-form ref="trademarkFormModal"></trademark-form>
    <context-menu ref="copyMenu"></context-menu>
    <b-modal id="agentTransactionsReportTrademarkModal" centered size="xl" no-close-on-backdrop ref="agentTransactionsReportTrademarkModal" :title=" $t('agentTransactionsReportTrademark.title')" hide-footer>
        <!-- table -->
        <b-row>
            <b-col class="col-md-12 mb-1 custom-search d-flex justify-content-end">
                <div class="d-flex align-items-right">
                    <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                </div>
            </b-col>
        </b-row>
        <vue-good-table id="agentTransactionsReportTrademarkTable" ref="agentTransactionsReportTrademarkTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :search-options="{
          enabled: true,
          externalQuery: searchTerm }" :pagination-options="{
          enabled: true,
          perPage:pageLength
        }">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Row -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'applicationNo'" class="text-nowrap">
                    <span>
                        {{ $t('agentTransactionsReportTrademark.application_no') }}
                        <br>
                        {{ $t('agentTransactionsReportTrademark.application_date') }}
                    </span>
                </span>
                <span v-else-if="props.column.field === 'registerNo'" class="text-nowrap">
                    <span>
                        {{ $t('agentTransactionsReportTrademark.register_no') }}
                        <br>
                        {{ $t('agentTransactionsReportTrademark.register_date') }}
                    </span>
                </span>
            </template>
            <!-- Column: Table Column -->
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'logo'" class="text-nowrap">
                    <b-row>
                        <b-col v-if="props.row.logo != null" class="font-size: x-small">
                            <b-img>{{ 'data:image/jpeg;base64,'.concat(props.row.logo) }}</b-img>
                            <b-img :src="'data:image/jpeg;base64,'.concat(props.row.logo)" fluid alt="Responsive image" />
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'recordNo'">
                    <b-row>
                        <b-col class="font-size: x-small">
                            <b-badge @contextmenu.prevent="openContextMenu($event, props.row.recordNo)" @click="showTrademarkInfoForm(props.row)" variant="primary" style="cursor: pointer;">
                                <feather-icon icon="MousePointerIcon" class="mr-25" />
                                <span>{{ props.row.recordNo }}</span>
                            </b-badge>
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'ownerList'">
                    <b-col>
                        <b-row v-for="owner in props.row.ownerList" v-bind:key="owner.clientName" style="font-size: small;">
                            <tr v-if="props.row.ownerList.length != 1">
                                <feather-icon class="featherIconReSize" icon="ArrowRightIcon" />
                                <span>{{ owner.clientName }} </span> <br />
                            </tr>
                            <tr v-else-if="props.row.ownerList.length == 1">
                                <span>{{ owner.clientName }} </span> <br />
                            </tr>
                        </b-row>
                    </b-col>
                </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                        </span>
                        <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                        <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </b-modal>
</div>
</template>

<script>
export default {
    data() {
        return {
            total: 0,
            pageLength: 50,
            dir: false,
            pageNo: 1,
            columns: [{
                    label: this.$t('agentTransactionsReportTrademark.logo'),
                    field: 'logo',
                },

                {
                    label: this.$t('agentTransactionsReportTrademark.referance_no'),
                    field: 'recordNo',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.name'),
                    field: 'name',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.agent'),
                    field: 'agent',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.owner'),
                    field: 'ownerList',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.application_no'),
                    field: 'applicationNo',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.register_no'),
                    field: 'registerNo',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.nice_class'),
                    field: 'niceClass',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.status'),
                    field: 'trademarkStatus',
                },
                {
                    label: this.$t('agentTransactionsReportTrademark.next_renewal_date'),
                    field: 'nextRenewalDate',
                    formatFn: this.$formatFn

                }
            ],
            rows: [],
            searchTerm: '',
            isAgent: false,
            isOwner: false,
            name: ''
        }
    },
    methods: {
        openContextMenu(event, row) {
            this.$refs.copyMenu.openContextMenu(event, row)
        },
        showTrademarkInfoForm(row) {
            this.$refs.trademarkFormModal.showInfo(row.id)
        },
        getAgentTransactionsReportList(recordType, clientAccountingId, allRecord = false) {
            this.$refs.agentTransactionsReportTrademarkModal.show()
            this.rows = []
            const data = {
                recordType: recordType,
                clientAccountingId: clientAccountingId,
                isAllRecord: allRecord
            }
            const controller = {
                name: 'Client',
                actionName: 'AgentTransactionsReportDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.trademarkList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        getOwnerTransactionsReportList(recordType, clientId) {

            this.$refs.agentTransactionsReportTrademarkModal.show()
            this.rows = []
            const data = {
                recordType: recordType,
                clientId: clientId
            }
            const controller = {
                name: 'Client',
                actionName: 'AgentTransactionsReportDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.trademarkList
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        exportExcel() {
            const controller = {
                name: 'Client',
                actionName: 'CanAgentExcelReport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Tüm İşlemler Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style>
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
